import { useTranslation } from '../../../components/Translation';

export default function SuccessStories() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col justify-center min-w-0">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-1 h-6 bg-dorado-uady rounded" />
        <h2 className="text-2xl font-bold text-azul-uady">{t('grupo.historias')}</h2>
      </div>
      <p className="text-gray-600 text-mini leading-relaxed text-justify">
        {t('grupo.hist_txt')}
      </p>
    </div>
  );
}